export default __webpack_public_path__ + "static/media/kvartir.928153cd.svg";